import useApiPlayground from './useApiPlayground'
import Button from '../../../../control/button/button'
import { Form } from 'react-final-form'
import TextField from '../../../../control/textfield/textfield'
import Autocomplete from '../../../../control/autocomplete/autocomplete'

type apiPlaygroundType = ReturnType<typeof useApiPlayground>
const ApiPlaygroundView = (props: apiPlaygroundType) => {
    const { onClickCallPostApi, onClickCallGetApi } = props
    return (
        <div>
            <h1> Call Api Example : :</h1>
            <div>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onClickCallPostApi}
                    style={{ margin: 10, marginLeft: 0 }}
                >
                    Call Post Example
                </Button>
                <Button variant="contained" color="primary" onClick={onClickCallGetApi}>
                    Call Get Example
                </Button>
            </div>
        </div>
    )
}

const ApiPlayground = () => {
    const formPlayground = useApiPlayground()
    return <ApiPlaygroundView {...formPlayground} />
}

export default ApiPlayground
